import { render, staticRenderFns } from "./VolumeDocuments.vue?vue&type=template&id=e0aacd3c&scoped=true"
import script from "./VolumeDocuments.vue?vue&type=script&lang=js"
export * from "./VolumeDocuments.vue?vue&type=script&lang=js"
import style0 from "./VolumeDocuments.vue?vue&type=style&index=0&id=e0aacd3c&prod&lang=scss"
import style1 from "./VolumeDocuments.vue?vue&type=style&index=1&id=e0aacd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aacd3c",
  null
  
)

export default component.exports